import find from 'lodash/find';
import config from '../config';

const { indexSlug, indexTitle } = config.nav;

export function getNodes(items) {
  return items.edges.map(edge => edge.node);
}

export function getPageTree(pages) {
  const root = find(pages, { slug: 'index' });
  return resolveSubtree(root);

  function resolveSubtree(page, path = '/') {
    page = {
      ...page,
      title: page.slug === indexSlug ? indexTitle : page.title,
      path,
    };

    let subpages = page.subpages || [];
    subpages = subpages.map(({ id }) => find(pages, { id }));
    page.subpages = subpages.map(page => resolveSubtree(page, `${path}${page.slug}/`));

    return page;
  }
}



// WEBPACK FOOTER //
// ./src/utils/contentful.js